"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Process() {
  const steps = [{
    number: "01",
    title: "PLANIFICACIÓN",
    description: "Sesión de descubrimiento inmersiva para entender los requisitos estructurales, el cronograma y los objetivos de su proyecto.",
    duration: "SEMANA 1"
  }, {
    number: "02",
    title: "CONCEPTUALIZACIÓN",
    description: "Diseño de cimientos sólidos y estrategias de encofrado adaptadas a las especificaciones técnicas de su obra.",
    duration: "SEMANAS 2-3"
  }, {
    number: "03",
    title: "GESTIÓN DE RECURSOS",
    description: "Selección de mano de obra calificada y materiales de alta resistencia para garantizar la integridad estructural.",
    duration: "SEMANAS 4-6"
  }, {
    number: "04",
    title: "EJECUCIÓN",
    description: "Ejecución precisa de encofrado y construcción general, cumpliendo con los más altos estándares de seguridad.",
    duration: "SEMANAS 7-10"
  }, {
    number: "05",
    title: "ENTREGA FINAL",
    description: "Inspección técnica detallada y entrega de una estructura sólida, lista para las siguientes fases de construcción.",
    duration: "SEMANA 11"
  }];
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}